import buildIndicatorQueryKey from '@Application/Indicators/buildIndicatorQueryKey';
import type { IndicatorPeriod, IndicatorScope } from '@Application/Indicators/IndicatorScope';

type Args = {
	scope: IndicatorScope;
	period: IndicatorPeriod;
	documentTypeId: number | null;
};

/** Reads the document indicators of a scope; `documentTypeId` narrows the headline figure only. */
class FetchDocumentIndicators {
	readonly scope: IndicatorScope;
	readonly period: IndicatorPeriod;
	readonly documentTypeId: number | null;
	readonly queryKey: string;

	constructor(args: Args) {
		this.scope = args.scope;
		this.period = args.period;
		this.documentTypeId = args.documentTypeId;
		this.queryKey = buildIndicatorQueryKey(args.scope, args.period, args.documentTypeId);

		Object.freeze(this);
	}

	toQueryString(): string {
		const params = new URLSearchParams({ period: String(this.period) });
		if (this.documentTypeId !== null) {
			params.set('documentType', String(this.documentTypeId));
		}

		return params.toString();
	}
}

export default FetchDocumentIndicators;
